export default __webpack_public_path__ + "static/media/6.86f62d1b.png";